import React, { useState, useContext, useEffect } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import '../style.css';
import { ThemeContext } from '../../../context/theme.context';
import TabPane from './TabPane';
import { useSelector } from 'react-redux';

const Splitter = () => {
  const [rendered, setRendered] = useState(false);
  const [status, setStatus] = useState(false);
  const largeMode = useSelector((state: any) => state.search.largeMode);
  const themeContext = useContext(ThemeContext);
  useEffect(() => {
    if (rendered) {
      expand();
    } else {
      setRendered(true);
    }
  }, [largeMode]);
  const expand = () => {
    const element = document.getElementById('expandable');
    if (status) {
      element?.classList.remove('layoutExpand');
      element?.classList.add('layoutCollapse');
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpand');
    }
    setStatus(!status);
  };

  const currentIcon = status ? (
    <FaAngleUp size='12px' />
  ) : (
    <FaAngleDown size='12px' />
  );

  return (
    <div>
      {/* <div className='main' onClick={expand}>
        {currentIcon}
      </div> */}
      <div id='expandable' className='layout'>
        {status ? <TabPane /> : null}
      </div>
    </div>
  );
};
export default Splitter;
